<template>
  <gj-table
      ref="gjTable"
      adaptParent
      :index="false"
      :loading="loading"
      :data="tableData"
      :columns="columns"
      :show-overflow="false"
      :pagination="pagination"
      :offset-height="viewOpType ? 345 : 395"
      @page-change="$gjNoticeQuery">
  </gj-table>
</template>

<script>
  import {opTypeMixin, queryMixin} from "../../../../../../minxins";
  import {ProductEnum} from "../../../../../../utils/options";

  export default {
    name: "app-product-operate-log",
    mixins: [queryMixin, opTypeMixin],
    props: {
      url: {
        type: String,
      },
      method: {
        type: String,
        default: 'post'
      },
      params: {
        required: false,
        default: () => {}
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
          {id: 'opUser', header: '操作用户', field: 'userName', minWidth: '100px'},
          {id: 'op', header: '操作分类', field: 'option:op', minWidth: '120px', options: ProductEnum.logTypeOption},
          {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '300px'},
        ]
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        this.$gjRequest({
          url: this.url,
          method: this.method,
          data: {
            ...this.params,
            ...this.queryPagination
          }
        })
          .then(({data}) => {
            this.tableData = (data.records || []);
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      }
    }
  }
</script>

<style scoped>

</style>
